import Model from '@/core/models/Model';

export default class JobListing extends Model {
  resource() {
    return 'jobs';
  }
}
